import { styled } from '@mui/material/styles';

import { InlineGroup } from '../../atoms/InlineGroup';
import { Typography } from '../../atoms/Typography';

export const Root = styled(InlineGroup)`
  width: 150px;
`;

export const PageLabel = styled(Typography)`
  width: 50px;
  text-align: center;
`;
